import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
const IconContainer = ({ width, height, children, className, isHoverable }) => {
    return (_jsx("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: "none", xmlns: "http://www.w3.org/2000/svg", className: classNames('svg-icon', { hoverable: isHoverable }, className), children: children }));
};
export default IconContainer;
